import type { MessageDescriptor, ReactIntlError } from 'react-intl';
import { createIntl } from 'react-intl';

import type { Language } from '../types';
import { Languages } from '../types';

import messages from './Raw.messages.json';

const LOCALE_EN = 'en';
// @ts-ignore TODO: fix types
const languagesList = Object.keys(Languages).filter((key) => !Number.isNaN(Number(Languages[key])));
export const matchLanguage = (locale: string): Language => {
  const langLower = locale.toLowerCase();
  // en => en
  // de => de
  if (languagesList.includes(langLower)) {
    return langLower as Language;
  }
  // en-uk => en
  // en-us => en
  // zh-tw => zh-tw
  if (langLower.includes('-')) {
    const localeToLang = langLower.replace(/-[A-Za-z]*$/, '');
    return languagesList.includes(localeToLang)
      ? (localeToLang as Language)
      : (Languages[Languages.en] as Language);
  }

  // Default to en
  return Languages[Languages.en] as Language;
};

const onError = (error: ReactIntlError): void => {
  // eslint-disable-next-line no-console
  console.warn('Translation error code: ', error.code);
};

/**
 * On first invocation creates a i18n object with the provided locale.
 * On the second - given a translation key as an ID - returns a translation value.
 */
export default function i8n(locale = LOCALE_EN, overrideTranslations = null) {
  const allTranslations = overrideTranslations || messages;
  const language = matchLanguage(locale);
  // @ts-ignore TODO: fix types
  const i18n = createIntl({ locale: language, messages: allTranslations[language], onError });

  return (id: MessageDescriptor['id']) => {
    const translated = i18n.formatMessage({ id });

    // If translated is different than the id, then we have a translation.
    if (id !== translated) {
      return translated;
    }

    // Missing EN translation
    if (language === LOCALE_EN) {
      throw new Error(`Missing translation for ${id}`);
    }

    // Try and fallback to english if no translation found so far.
    // @ts-ignore TODO: fix types
    const enI18n = createIntl({ locale: LOCALE_EN, messages: allTranslations.en, onError });
    const enTranslated = enI18n.formatMessage({ id });

    if (enTranslated !== id) {
      return enTranslated;
    }

    // Missing EN translation
    throw new Error(`Missing translation for ${id}`);
  };
}
